module.exports = __webpack_public_path__ + "68efdc8252afba9ae99b7f27dc5be6e4.svg";